import { FC } from "react"
import { Outlet } from "react-router-dom";
import { CommonFooter } from "../parts/CommonFooter";

export const EmptyLayout: FC = () => {
  return  <>
    <div className="">
      <div className="w-full">
        <Outlet />
      </div>
      <CommonFooter />
    </div>
  </>
}